const PolitiqueConfidentialite = () => {
  return (
    <section className="section-padding bg-background">
      <div className="max-w-3xl mx-auto prose prose-sm">
        <h1 className="font-heading text-3xl font-bold text-foreground">Politique de confidentialité</h1>
        <p className="text-muted-foreground italic font-body">Dernière mise à jour : mars 2026</p>

        <h2 className="font-heading text-xl font-semibold text-foreground mt-8">1. Responsable du traitement</h2>
        <p className="text-muted-foreground font-body">
          Body by CC — Carine Tchuente<br />
          65 Bd Westinghouse, 93270 Sevran<br />
          Email : <a href="mailto:kreent@yahoo.fr" className="text-primary hover:underline">kreent@yahoo.fr</a><br />
          Téléphone : 06 45 23 00 34
        </p>

        <h2 className="font-heading text-xl font-semibold text-foreground mt-8">2. Données collectées</h2>
        <p className="text-muted-foreground font-body">Les données personnelles collectées via le formulaire de contact sont : nom, prénom, email, téléphone et message. Ces données sont utilisées uniquement pour répondre à vos demandes.</p>

        <h2 className="font-heading text-xl font-semibold text-foreground mt-8">3. Finalité du traitement</h2>
        <p className="text-muted-foreground font-body">Les données sont traitées pour : répondre aux demandes de contact, gérer les prises de rendez-vous et améliorer nos services.</p>

        <h2 className="font-heading text-xl font-semibold text-foreground mt-8">4. Durée de conservation</h2>
        <p className="text-muted-foreground font-body">Les données sont conservées pendant une durée maximale de 12 mois à compter du dernier contact.</p>

        <h2 className="font-heading text-xl font-semibold text-foreground mt-8">5. Droits des utilisateurs</h2>
        <p className="text-muted-foreground font-body">Conformément au RGPD, vous disposez d'un droit d'accès, de rectification, de suppression, d'opposition et de portabilité de vos données. Pour exercer ces droits : <a href="mailto:kreent@yahoo.fr" className="text-primary hover:underline">kreent@yahoo.fr</a></p>

        <h2 className="font-heading text-xl font-semibold text-foreground mt-8">6. Cookies</h2>
        <p className="text-muted-foreground font-body">Le site utilise des cookies pour améliorer l'expérience utilisateur et analyser le trafic. Vous pouvez gérer vos préférences via le bandeau cookies ou les paramètres de votre navigateur.</p>

        <h2 className="font-heading text-xl font-semibold text-foreground mt-8">7. Sécurité</h2>
        <p className="text-muted-foreground font-body">Nous mettons en œuvre des mesures techniques et organisationnelles appropriées pour protéger vos données personnelles.</p>

        <h2 className="font-heading text-xl font-semibold text-foreground mt-8">8. Contact</h2>
        <p className="text-muted-foreground font-body">
          Pour toute question relative à cette politique : <a href="mailto:kreent@yahoo.fr" className="text-primary hover:underline">kreent@yahoo.fr</a>
        </p>
      </div>
    </section>
  );
};

export default PolitiqueConfidentialite;